// ON! Suite Design System — component-level tokens. Colors resolve to CSS variables in index.css.

export const STATUS = {
  green: { badge: "bg-emerald-50 text-emerald-700 border-emerald-200", dot: "bg-emerald-500", icon: "bg-emerald-50 text-emerald-600", text: "text-emerald-700" },
  amber: { badge: "bg-amber-50 text-amber-800 border-amber-200", dot: "bg-amber-500", icon: "bg-amber-50 text-amber-600", text: "text-amber-700" },
  red: { badge: "bg-red-50 text-red-700 border-red-200", dot: "bg-red-500", icon: "bg-red-50 text-red-600", text: "text-red-600" },
  blue: { badge: "bg-sky-50 text-sky-800 border-sky-200", dot: "bg-sky-500", icon: "bg-sky-50 text-sky-700", text: "text-sky-700" },
  neutral: { badge: "bg-slate-100 text-slate-600 border-slate-200", dot: "bg-slate-400", icon: "bg-slate-100 text-slate-600", text: "text-slate-900" },
  brand: { badge: "bg-brand-50 text-brand-700 border-brand-200", dot: "bg-brand-500", icon: "bg-brand-50 text-brand-600", text: "text-brand-700" },
};

export const TYPE = {
  h1: "font-display text-2xl font-bold tracking-tight text-ink sm:text-[28px]",
  h2: "font-display text-lg font-bold tracking-tight text-ink",
  h3: "text-sm font-semibold text-ink",
  body: "text-sm text-slate-600",
  caption: "text-xs text-slate-500",
  overline: "text-[11px] font-semibold uppercase tracking-[0.16em] text-slate-400",
  metric: "font-display text-3xl font-bold tracking-tight text-ink",
};

export const SURFACE = {
  card: "rounded-card border border-line bg-surface shadow-card",
  subtle: "rounded-control bg-slate-50",
};

export const NAV = {
  item: "group relative flex items-center gap-3 rounded-control px-3 py-2 text-sm font-medium transition-colors",
  active: "bg-brand-50 text-ink before:absolute before:left-0 before:top-2 before:bottom-2 before:w-[3px] before:rounded-full before:bg-brand-500",
  idle: "text-slate-600 hover:bg-slate-100 hover:text-ink",
  iconActive: "text-brand-600",
  iconIdle: "text-slate-400 group-hover:text-slate-600",
};

export const CHIP = {
  action: "inline-flex items-center gap-1 rounded-control border border-brand-200 bg-white px-2.5 py-1 text-xs font-semibold text-brand-700 transition-colors hover:bg-brand-50",
};
